import React, { useState } from 'react';

import {
    Table, Col, Row, Image,
} from 'react-bootstrap';

import FileUpload from '../blocks/file_upload_block';

export default function HotboxScreen() {
    const [data, setData] = useState(['https://vkplay.ru/hotbox/content_files/960723 2.jpg']);

    function handleFileLoad(newData) {
        setData([
            newData.url,
            ...data,
        ]);
    }

    return (
        <div>
            <Row className="show-grid">
                <Col md={12}>
                    <h3>
                        Загрузка файлов в Хотбокс
                    </h3>
                </Col>
            </Row>
            <Row md={12} className="mt-2">
                <Col>
                    <FileUpload directory="media" onLoad={handleFileLoad} />
                </Col>
            </Row>
            <Row md={12} className="mt-5">
                <Col md={12}>
                    <h5>Список файлов</h5>
                </Col>
            </Row>
            <Row md={12}>
                <Col md={12}>
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>Url</th>
                                <th>Превью</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item) => (
                                <tr key={item}>
                                    <th>{item}</th>
                                    <th><Image src={item} fluid rounded style={{ maxWidth: '150px' }} /></th>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    );
}
